export default "__VITE_ASSET__3f9f87ca__"